import type { DocNode } from '@atlaskit/adf-schema';
import { ADFEncoder } from '@atlaskit/renderer/utils';
import { findFilepaths, isLinkInMatches } from '@atlaskit/editor-common/utils';

import type { ConfluenceDeepResearchPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { AiMateMarkdownTransformer } from '@atlassian/conversation-assistant-content-transformer';
import {
	type PassThroughCommandProps,
	StreamingCommandHandler,
} from '@atlassian/editor-rovo-bridge';

import { log } from '../utils/aifc-logging.ts';

export class DeepResearchCommandHandler extends StreamingCommandHandler<ConfluenceDeepResearchPageCreateCommandProperties> {
	// Streaming Markdown -> ADF encoder for Deep Research content
	private streamingAdfEncoder: ADFEncoder<string>;
	private streamedMd = '';

	constructor(props: PassThroughCommandProps) {
		super(props, 'deep-research-create');
		const pluginConfig = {
			linkify: { findFilepaths, isLinkInMatches },
			smartLinks: { regexStorage: globalThis.localStorage },
		};
		this.streamingAdfEncoder = new ADFEncoder(
			(schema) => new AiMateMarkdownTransformer(schema, pluginConfig, true),
		);
	}

	async process(payload: ConfluenceDeepResearchPageCreateCommandProperties): Promise<void> {
		if (payload.isStreamComplete) {
			this.streamedMd = payload.data.content;
		} else {
			this.streamedMd += payload.data.content;
		}

		const adfDoc = this.streamingAdfEncoder.encode(this.streamedMd);

		// Temporarily using replaceDocument since the editor streaming plugin does not support streaming MD or multiple ADF docs
		this.props.editorAPI.core.actions.replaceDocument(adfDoc, { scrollIntoView: false });
	}

	async finishAction(): Promise<DocNode | undefined> {
		log('handle confluence-deep-research-page-create-command');
		const adfDoc = this.streamedMd ? this.streamingAdfEncoder.encode(this.streamedMd) : undefined;
		this.streamedMd = '';
		return adfDoc;
	}

	abort(): void {
		// No-op
	}
}
